<template>
  <v-container fluid>
    <div class="d-flex flex-column flex-md-row justify-space-between">
      <div>
        <h1>{{ $t('EDIT_COLLABORATOR.TITLE.HEADER') }}</h1>
        <span>{{ $t('EDIT_COLLABORATOR.TITLE.SUBTITLE') }}</span>
      </div>
      <div class="d-flex align-center justify-md-center justify-start mt-8 mt-md-0">
        <v-btn class="boom-button-back" variant="outlined" @click="returnRedirection">
          {{ $t('COMMON.BUTTON.BACK') }}
        </v-btn>
      </div>
    </div>
    <v-card class="rounded-xl mt-8 flex-fill" :border="false" :elevation="0">
      <v-form ref="formProfile" v-model="formValid" @submit.prevent="submitEditCollaborator">
        <v-row>
          <v-col cols="12">
            <h3 class="font-weight-bold">{{ $t('EDIT_COLLABORATOR.PERSONAL_INFO') }}</h3>
          </v-col>
          <v-col cols="12" md="6">
            <p data-custom="true">{{ $t('EDIT_COLLABORATOR.FIRSTNAME') }}</p>
            <v-text-field required v-model.trim="collaborator.firstname" :rules="requiredRules">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <p data-custom="true">{{ $t('EDIT_COLLABORATOR.LASTNAME') }}</p>
            <v-text-field required v-model.trim="collaborator.lastname" :rules="requiredRules">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <p>{{ $t('EDIT_COLLABORATOR.JOB_DESCRIPTION') }}</p>
            <v-text-field v-model.trim="collaborator.job_description"></v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              class="boom-button"
              variant="outlined"
              :disabled="!formValid || loading"
              :loading="loading"
              type="submit"
            >
              {{ $t('EDIT_COLLABORATOR.BUTTON.UPDATE') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { displayToast } from '@/components/utils/globalFunction'
import Validator from '@/components/utils/validator'
import CollaboratorService from '@/services/CollaboratorService'
import router from '@/router'

export default {
  name: 'ProfileEditCollaboratorPage',

  data() {
    return {
      formValid: false,
      loading: false,
      collaborator: {},
      requiredRules: Validator.requiredRules
    }
  },
  async created() {
    this.loading = true
    try {
      this.collaborator = await CollaboratorService.getCollaborator(
        this.$route.params.collaboratorId
      )
      this.loading = false
    } catch (error) {
      let text = this.$t('ERROR_STATUS_CODE_MESSAGE.' + error.response.status)
      if (
        error.response &&
        error.response.data &&
        error.response.data.key === 'collaborator_does_not_exist_error_key'
      ) {
        text = this.$t('EDIT_COLLABORATOR.ERROR.NO_COLLABORATOR')
      }
      displayToast(text, 'error')
      this.loading = false
    }
  },
  methods: {
    async submitEditCollaborator() {
      this.loading = true
      const updateCollaborator = {
        firstname: this.collaborator.firstname,
        technical_id: this.collaborator.technical_id,
        ...(this.collaborator.job_description
          ? { job_description: this.collaborator.job_description }
          : {}),
        lastname: this.collaborator.lastname,
        status: this.collaborator.status
      }
      try {
        const response = await CollaboratorService.updateCollaborator(updateCollaborator)
        await this.$store.commit('auth/updateOneCollaboratorsInList', response)
        displayToast(this.$t('EDIT_COLLABORATOR.SUCCESS'), 'success')
        await router.push({ path: '/profile' })
        this.loading = false
      } catch (error) {
        let text = this.$t('EDIT_COLLABORATOR.ERROR.NO_COLLABORATOR')
        if (
          error.response &&
          error.response.data &&
          error.response.data.key === 'user_already_exists_error_key'
        ) {
          text = this.$t('EDIT_COLLABORATOR.ERROR.USER_EXIST')
        }
        displayToast(text, 'error')
      }
      this.loading = false
    },
    checkPermission(permissionsRequired) {
      return this.$store.getters['auth/hasPermission'](permissionsRequired)
    },
    async returnRedirection() {
      await router.push({ path: '/profile' })
    }
  }
}
</script>

<style scoped>
.v-container {
  padding: 32px;
}

.v-card {
  padding: 32px;
}

.v-form p {
  margin-bottom: 16px;
}

th > * {
  color: white;
}

tr:nth-of-type(even) {
  background-color: #fafafa;
}
</style>
